import { useMemo } from "react";
import { useApi } from "src/hooks/useApi";
import {
    findConflicts,
    findDuplicateCodes,
    findMaxCountViolations,
    type ExclusionRule,
    type MaxCountRule,
} from "src/helpers/goaRules";
import { activeRows, type GoaLineDraft } from "./goaLineDraft";

/** Live issues for one date's draft rows. /goa/validate only sees what's already persisted, so
 * it can't catch these before save. Exclusion/max-count rules are Pro (the endpoint returns 403
 * otherwise and those lists simply stay empty); duplicate codes are checked on every plan. */
export function useGoaLineIssues(rows: GoaLineDraft[]) {
    const { data: ruleData } = useApi<{ rules: ExclusionRule[]; maxCountRules: MaxCountRule[] }>("/goa/exclusion-rules");
    const active = useMemo(() => activeRows(rows), [rows]);
    const conflicts = useMemo(() => findConflicts(active, ruleData?.rules ?? []), [active, ruleData]);
    const maxCountViolations = useMemo(() => findMaxCountViolations(active, ruleData?.maxCountRules ?? []), [active, ruleData]);
    const duplicateCodes = useMemo(() => findDuplicateCodes(active), [active]);
    return { conflicts, maxCountViolations, duplicateCodes };
}

export type GoaLineIssues = ReturnType<typeof useGoaLineIssues>;
